class TaskStep {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

const stepStatus = {
    Inprogress: 'INPROGRESS',
    New: 'NEW',
    Complete: 'COMPLETE',
    Abandon: 'ABANDON',
    Cancel: 'CANCEL',
    Submitted: 'SUBMIT'
};

class License {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class Tranings {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class WorkDetails {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class WorkDetailsLib {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

const initialState = {};

class Address {
    constructor(obj) {
        Object.assign(this, obj);
    }
}
// Addedd FirmFormAddres
class FirmAddress {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class Template {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class PAObservation {
}
class PAChart {
}
class PACategoryDetails {
}

class VisaDetails {
    constructor(obj) {
        Object.assign(this, obj);
    }
}
class VisaMeta {
    constructor(obj) {
        Object.assign(this, obj);
    }
}
class TravelHistory {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

class WorkExpDetails {
    constructor(obj) {
        Object.assign(this, obj);
    }
}

const ATTORNEY = 'Attorney';
const PETITIONER = 'Petitioner';
const BENEFICIARY = 'Beneficiary';
const PLATFORMADMIN = 'Platform';
var userRoleRouteMapping;
(function (userRoleRouteMapping) {
    userRoleRouteMapping["Petitioner"] = "petitioner-landing";
    userRoleRouteMapping["Attorney"] = "attorney-landing";
    userRoleRouteMapping["Beneficiary"] = "beneficiary-landing";
    userRoleRouteMapping["Platform"] = "platform-admin-landing";
})(userRoleRouteMapping || (userRoleRouteMapping = {}));

const VIDEOS = {
    BENEFICIARY_VIDEOS: [{
            sectionName: 'Imagility for Beneficiaries',
            url: 'https://player.vimeo.com/video/518582941?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Building Beneficiary Profile",
            url: 'https://player.vimeo.com/video/518582858?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Compliance",
            url: '',
            links: [{
                    sectionName: "FDNS Details",
                    url: 'https://player.vimeo.com/video/585297061?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
                },
                {
                    sectionName: "Compliance Public and Private Access File",
                    url: 'https://player.vimeo.com/video/585296967?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
                }]
        },
        {
            sectionName: "Using Timelines and Notifications for Beneficiary",
            url: 'https://player.vimeo.com/video/518552861?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Designing A Job Description",
            url: 'https://player.vimeo.com/video/518507712?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to create a H1-B Petition",
            url: '',
            links: [{
                    sectionName: 'Part 1: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948515?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        // {
        //   sectionName : "Part 2: How to build a Petition",
        //   url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        // },
        {
            sectionName: "Importance of Speciality Occupation",
            url: 'https://player.vimeo.com/video/518554434?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        }],
    ATTORNEY_VIDEOS: [{
            sectionName: 'Imagility for Lawfirms',
            url: 'https://player.vimeo.com/video/518582501?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: 'Imagility Navigation for Lawfirms',
            url: 'https://player.vimeo.com/video/530250636?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Building Beneficiary Profile",
            url: 'https://player.vimeo.com/video/518582858?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Designing A Job Description",
            url: 'https://player.vimeo.com/video/518507712?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Importance of Speciality Occupation",
            url: 'https://player.vimeo.com/video/518554434?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to create Tasks",
            url: 'https://player.vimeo.com/video/518550775?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Creating RFE Sub Task for petition created outside Imagility",
            url: 'https://player.vimeo.com/video/584794763?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Creating RFE Sub Task for petition created through Imagility",
            url: 'https://player.vimeo.com/video/584797978?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Next steps after Tasks creation",
            url: 'https://player.vimeo.com/video/518576512?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to create a H1-B Petition",
            url: '',
            links: [{
                    sectionName: 'Part 1: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948515?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        {
            sectionName: "How to build a H-1B petition",
            url: '',
            links: [{
                    sectionName: 'Part 1 How to Build a H-1B Petition',
                    url: 'https://player.vimeo.com/video/665524738?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2 How to Build a H-1B Petition',
                    url: 'https://player.vimeo.com/video/665526024?h=73f0f03534?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        {
            sectionName: "Building an RFE Response",
            url: '',
            links: [{
                    sectionName: 'Part 1: Building an RFE Response',
                    url: 'https://player.vimeo.com/video/584799030?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2: Building an RFE Response',
                    url: 'https://player.vimeo.com/video/584800721?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        // {
        //   sectionName : "Part 2: How to build a Petition",
        //   url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        // },
        {
            sectionName: "How to use Notifications to collabrate?",
            url: 'https://player.vimeo.com/video/518583015?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Picking the right LCA",
            url: 'https://player.vimeo.com/video/518579514?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        }
    ],
    PETITIONER_VIDEOS: [{
            sectionName: 'Imagility for Petitioners',
            url: 'https://player.vimeo.com/video/518583749?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Building Beneficiary Profile",
            url: 'https://player.vimeo.com/video/518582858?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to create Tasks",
            url: 'https://player.vimeo.com/video/518550775?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Creating RFE Sub Task for petition created outside Imagility",
            url: 'https://player.vimeo.com/video/584794763?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Creating RFE Sub Task for petition created through Imagility",
            url: 'https://player.vimeo.com/video/584797978?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Next steps after Tasks creation",
            url: 'https://player.vimeo.com/video/518576512?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to create a H1-B Petition",
            url: '',
            links: [{
                    sectionName: 'Part 1: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948515?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2: How to build a Petition',
                    url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        {
            sectionName: "How to build a H-1B petition",
            url: '',
            links: [{
                    sectionName: 'Part 1 How to Build a H-1B Petition',
                    url: 'https://player.vimeo.com/video/665524738?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2 How to Build a H-1B Petition',
                    url: 'https://player.vimeo.com/video/665526024?h=73f0f03534?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        {
            sectionName: "Building an RFE Response",
            url: '',
            links: [{
                    sectionName: 'Part 1: Building an RFE Response',
                    url: 'https://player.vimeo.com/video/584799030?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                },
                {
                    sectionName: 'Part 2: Building an RFE Response',
                    url: 'https://player.vimeo.com/video/584800721?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                }]
        },
        // {
        //   sectionName : "Part 2: How to build a Petition",
        //   url: 'https://player.vimeo.com/video/518948679?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        // },
        {
            sectionName: "How to use Notifications to collabrate?",
            url: 'https://player.vimeo.com/video/518583015?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
        },
        {
            sectionName: "Designing A Job Description",
            url: 'https://player.vimeo.com/video/518507712?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Importance of Speciality Occupation",
            url: 'https://player.vimeo.com/video/518554434?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Picking the right LCA",
            url: 'https://player.vimeo.com/video/518579514?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "How to Build Reports on Imagility",
            url: 'https://player.vimeo.com/video/665524422?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        },
        {
            sectionName: "Compliance",
            url: '',
            links: [{
                    sectionName: "FDNS Details",
                    url: 'https://player.vimeo.com/video/585297061?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
                },
                {
                    sectionName: "Compliance Public and Private Access File",
                    url: 'https://player.vimeo.com/video/585296967?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
                }]
        }
    ]
};

const VisaTypeList = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'O1A', 'O1B', 'TN1', 'TN2', 'H1-B'];
const DEPENDENT_VISAS = ["R2", "P4", "TD", "ED", "O3", "L2", "H4", "K1", "K3", "U2", "U3", "U4", "U5", "UD", "UQ"];
const IMMIGRANT_FORMS = ['I485FORM', 'I589FORM', 'I751FORM', 'I131FORM', 'I601FORM',
    'I601AFORM', 'I821DFORM', 'I360FORM', 'I765FORMIMM', 'I864FORM', 'I864WFORM', 'I821FORM', 'I191FORM',
    'I881FORM', 'I730FORM', 'DS260FORM', 'ETA9141FORMIMM', 'N400FORM', 'I130FORM', 'I90FORM', 'I140FORM',
    'N600FORM', 'I526FORM', 'I526EFORM', 'AR11FORMIMM', 'I829FORM', 'EOIR33FORM', 'EOIR42BFORM', 'EOIR45FORM',
    'EOIR58FORM', 'EOIR40FORM', 'EOIR44FORM', 'EOIR45FORM', 'EOIR31FORM', 'EOIR31A', 'EOIR42A', 'EOIR26', 'EOIR29',
    'EOIR30', 'EOIR59', 'EOIR60', 'EOIR61', 'EOIR56FORM', 'EOIR33BIAFORM', 'EOIR33ICFORM', 'I290BFORM'];
const STEPS_WITH_TABS_IN_POPUP = ['BENEFICIARY_DETAIL', 'BEN_BENEFICIARY_DETAIL', 'PRIMARY_APPLICANT_DETAILS', 'SECONDARY_APPLICANT_DETAILS', 'BEN_PRIMARY_APPLICANT_DETAILS', 'BEN_SECONDARY_APPLICANT_DETAILS', 'SPOUSE_DETAIL', 'CHILD_DETAIL', 'BEN_SPOUSE_DETAIL', 'BEN_CHILD_DETAIL', 'PERSONAL_DETAIL'];
const APPLICANT_TABS = [{
        name: 'Personal Details',
        code: 'PERSONAL_DETAILS',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Address History',
        code: 'ADDR_HISTORY',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Marital History',
        code: 'MARITAL_HISTORY',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Family Information',
        code: 'FAMILY_INFO',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Parent Information',
        code: 'PARENT_INFO',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Employment History',
        code: 'EMP_INFO',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Immigration History',
        code: 'IMM_INFO',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Additional Information',
        code: 'ADD_INFO',
        isLastTab: false,
        showTab: false
    }, {
        name: 'Required Documents',
        code: 'DOC_INFO',
        isLastTab: false,
        showTab: false,
        docType: ''
    }, {
        name: 'Required Documents - Family',
        code: 'IMM_DOC_INFO',
        isLastTab: false,
        showTab: false,
        docType: ''
    }];
const USCIS_CONFIG = [{ name: 'Show Mailing Address', value: true }, { name: 'Show Consulate Address', value: false }, { name: 'Show Fee Calculation', value: true, includeDependentsFee: true }, { name: 'Show Generate Forms', value: true, showDependentForm: true }, { name: 'Show Port of Entry', value: false }, {
        "name": "Show Card Information",
        "value": true
    }];
const GENERATE_FORM_CONFIG = [{ name: 'Show Cover Letter', value: true }, { name: 'Show Support Letter', value: true }, { name: 'Show Organise Documents', value: true }];
const GENERATE_EFILING_FORM_CONFIG = [{ name: 'Show Cover Letter', value: true }, { name: 'Show Support Letter', value: false }, { name: 'Show Organise Documents', value: false }];
const DOCTYPESCONST = [{
        name: 'BENPASSDOC',
        code: 'BENPASSDOC'
    },
    {
        name: 'BENIMMDOC',
        code: 'BENIMMDOC'
    }, {
        name: 'BENOTHDOCASYLEE',
        code: 'BENOTHDOCASYLEE'
    }, {
        name: 'BENOTHDOC',
        code: 'BENOTHDOC'
    }, {
        name: 'SPONSOROTHDOC',
        code: 'SPONSOROTHDOC'
    }, {
        name: 'HSHLDMMBROTHDOC',
        code: 'HSHLDMMBROTHDOC'
    }, {
        name: 'SPOUSEOTHDOC',
        code: 'SPOUSEOTHDOC'
    }, {
        name: 'CHILDOTHDOC',
        code: 'CHILDOTHDOC'
    }, {
        name: 'PARENTOTHDOC',
        code: 'PARENTOTHDOC'
    }, {
        name: 'SIBLINGOTHDOC',
        code: 'SIBLINGOTHDOC'
    }, {
        name: 'FIANCEOTHDOC',
        code: 'FIANCEOTHDOC'
    }];

const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
const BENE_SELF_READ = 'Beneficiary_Self_Read';
const BENE_SPOUSE_WRITE = 'Beneficiary_Spouse_Write';
const BENE_SPOUSE_READ = 'Beneficiary_Spouse_Write';
// export const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
// export const BENE_SELF_READ = 'Beneficiary_Self_Read';
// export const BENE_SELF_WRITE = 'Beneficiary_Self_Write';
// export const BENE_SELF_READ = 'Beneficiary_Self_Read';
const USER_PERMISSIONS = {
    ASSIGN_PERMISSION: 'ASSIGN_PERMISSION',
    ASSIGN_ROLE: 'ASSIGN_ROLE',
    DEL_PETITION: 'DEL_PETITION',
    DELETE_COMPANY: 'DELETE_COMPANY',
    DELETE_PERMISSION: 'DELETE_PERMISSION',
    DELETE_PETITION: 'DELETE_PETITION',
    EDIT_BENEFICIARY: 'EDIT_BENEFICIARY',
    EDIT_COMPANY: 'EDIT_COMPANY',
    EDIT_EMPLOYEES: 'EDIT_EMPLOYEES',
    EDIT_LINK: 'EDIT_LINK',
    EDIT_PERMISSION: 'EDIT_PERMISSION',
    EDIT_PETITION: 'EDIT_PETITION',
    EDIT_ROLE: 'EDIT_ROLE',
    UNASSIGN_ROLE: 'UNASSIGN_ROLE',
    VIEW_ASSOC_COMPANY: 'VIEW_ASSOC_COMPANY',
    VIEW_BENEFICIARY: 'VIEW_BENEFICIARY',
    VIEW_COMPANY: 'VIEW_COMPANY',
    VIEW_EMPLOYEES: 'VIEW_EMPLOYEES',
    VIEW_PERMISSION: 'VIEW_PERMISSION',
    VIEW_PETITION: 'VIEW_PETITION',
    VIEW_ROLE: 'VIEW_ROLE',
    PETITIONER_STATS: 'PETITIONER_STATS',
    PETITION_REVIEWER: 'PETITION_REVIEWER'
};

const labelNotNeededArray = ['CustomCalenderComponent', 'CustomDropdownComponent', 'AddressDetailsComponent',
    'VdSwitchGroupComponent', 'CustomQuestionsGroupComponent', 'VdLabelComponent',
    'VdDividerComponent', 'VdTextAreaComponent', 'CustomGridEditor', 'CustomTextFieldComponent',
    'VdEadLibraryComponent', 'VdAddGenerateFormComponent', 'DOC_UPLOAD', 'PERSON_DTL', 'VdCountryStateComponent', 'CustomButtonComponent',
    'CustomButtonActionComponent', 'CustomDateTimePickerComponent',
    'FdMasterTableListCardComponent', 'FbCustomDatePickerGroupComponent',
    'CustomNumberFieldComponent', 'LibLeaveSummaryComponent', 'LibResignationSummaryComponent',
    'MarkInOutComponent', 'TimesheetSummary', 'CorrectionSummary', 'OvertimeSummary', 'ShortbreakSummary',
    'DailyAttendanceSummary', 'ViewProject', 'CreateProjectTimesheet', 'ViewProjectTimesheet',
    'RequisitionDecisionStatus', 'RolesResponsibility', 'CreateInvoice', 'GenerateReceipt', 'PdfViewer',
    'CustomReadonlyLabelValueLibraryComponent', 'CustomPeriodSelectionComponent', 'ViewPayslipComponent',
    'BulkUploadDashboardComponent', 'TalentEditDetailsComponent', 'NewTalentUploadComponent', 'LibViewClientInfoComponent', 'LibEvaluationDetailsComponent',
    'ViewCandidateDetailsComponent', 'LibTemplateBuilderComponent', 'LibTemplateViewer', 'LibAssignMultipleJobIdComponent', 'LibPreviewInvoiceComponent', 'EfilingVersionStatusComponent'];

const HAIRCOLORS = [{ name: 'Select', code: '' }, { name: 'Bald(No hair)', code: 'Bald No Hair' }, { name: 'Black', code: 'Black' }, { name: 'Blond', code: 'Blond' }, { name: 'Brown', code: 'Brown' }, { name: 'Gray', code: 'Gray' }, { name: 'Red', code: 'Red' }, { name: 'Sandy', code: 'Sandy' }, { name: 'White', code: 'White' }, { name: 'Unknown/Other', code: 'Unknown Other' }];
const EYECOLORS = [{ name: 'Select', code: '' }, { name: 'Black', code: 'Black' }, { name: 'Brown', code: 'Brown' }, { name: 'Blue', code: 'Blue' }, { name: 'Gray', code: 'Gray' }, { name: 'Green', code: 'Green' }, { name: 'Hazel', code: 'Hazel' }, { name: 'Maroon', code: 'Maroon' }, { name: 'Pink', code: 'Pink' }, { name: 'Unknown/Other', code: 'Unknown Other' }];

const MAILING_LIST = [{ name: 'Select', code: '' }, { name: 'Physical Address', code: 'CURR' }];
const FOREIGN_LIST = [{ name: 'Select', code: '' }, { name: 'Physical Address', code: 'CURR' }, { name: 'Mailing Address', code: 'MAIL' }];
const PERMANENT_LIST = [{ name: 'Select', code: '' }, { name: 'Physical Address', code: 'CURR' }, { name: 'Mailing Address', code: 'MAIL' }, { name: 'Foreign Address', code: 'FORN' }];

const acceptedFileTypes = 'application/pdf,image/png,image/jpg,image/jpeg';
const fileSizeText = 'Max file size is 10 MB';
const acceptedFileTypesText = `${fileSizeText} | PDF, PNG, JPG, JPEG file types are allowed`;
const acceptedFileTypesTextPDF = `${fileSizeText} | PDF file type is allowed`;

const possibleDateFormats = [
    'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD',
    'DD-MM-YYYY', 'MM-DD-YYYY', 'DD.MM.YYYY', 'YYYY.MM.DD'
];

const BEN_STATUSES = { ACTIVE: ['ACTIVE', 'PEND', 'TERMINATED'], PEND: ['PEND'], TERMINATED: ['TERMINATED'] };

var NotifyCodeAction;
(function (NotifyCodeAction) {
    NotifyCodeAction["IOSDTL_STP"] = "IOSDTL_STP";
    NotifyCodeAction["RVW_PTON_SEND_BACK_STP"] = "RVW_PTON_SEND_BACK_STP";
    NotifyCodeAction["RVW_PTON_COM_STP"] = "RVW_PTON_COM_STP";
    NotifyCodeAction["PROJECT_DTLS_STP"] = "PROJECT_DTLS_STP";
    NotifyCodeAction["SUPPORT_LTR_STP"] = "SUPPORT_LTR_STP";
    NotifyCodeAction["LINKREQ"] = "LINKREQ";
    NotifyCodeAction["OCCPDTL_STP"] = "OCCPDTL_STP";
    NotifyCodeAction["WRKLOC_STP"] = "WRKLOC_STP";
    NotifyCodeAction["LSTDUTY_STP"] = "LSTDUTY_STP";
    NotifyCodeAction["EDUWE_STP"] = "EDUWE_STP";
    NotifyCodeAction["BEN_POS_DETAIL_STP"] = "BEN_POS_DETAIL_STP";
    NotifyCodeAction["DOCREJECT"] = "DOCREJECT";
    NotifyCodeAction["DOCMISS"] = "DOCMISS";
    NotifyCodeAction["TASKREQ"] = "TASKREQ";
    NotifyCodeAction["RFEDOCMISSRFERESPONSEREQ"] = "RFE_DOC_MISSRFE_RESPONSE_REQ";
    NotifyCodeAction["RFEDOCMISS"] = "RFE_DOC_MISS";
    NotifyCodeAction["RFERESPONSEREQ"] = "RFE_RESPONSE_REQ";
    NotifyCodeAction["ETA_NOTICE"] = "ETA_NOTICE // ETA Notice";
    NotifyCodeAction["LCA_ACKNOWLEDGEMENT_REQ"] = "LCA_ACKNOWLEDGEMENT_REQ";
})(NotifyCodeAction || (NotifyCodeAction = {}));
var NotifyCodeNoAction;
(function (NotifyCodeNoAction) {
    NotifyCodeNoAction["BUILD_PETITION_STP"] = "BUILD_PETITION_STP";
    NotifyCodeNoAction["GETRCPT_ATTOR_STP"] = "GETRCPT_ATTOR_STP";
    NotifyCodeNoAction["GETRCPT_PET_STP"] = "GETRCPT_PET_STP";
    NotifyCodeNoAction["SUBTPTION_ATTOR_STP"] = "SUBTPTION_ATTOR_STP";
    NotifyCodeNoAction["SUBTPTION_PET_STP"] = "SUBTPTION_PET_STP";
    NotifyCodeNoAction["RVWDOCS_STP"] = "RVWDOCS_STP";
    NotifyCodeNoAction["WAIT_DCSON_COMP_PT_STP"] = "WAIT_DCSON_COMP_PT_STP";
    NotifyCodeNoAction["WAIT_DCSON_COMP_ATT_STP"] = "WAIT_DCSON_COMP_ATT_STP";
    NotifyCodeNoAction["WAIT_DCSON_RFE_PT_STP"] = "WAIT_DCSON_RFE_PT_STP";
    NotifyCodeNoAction["WAIT_DCSON_RFE_AT_STP"] = "WAIT_DCSON_RFE_AT_STP";
    NotifyCodeNoAction["AWAIT_LOTTERY_STP"] = "AWAIT_LOTTERY_STP";
    NotifyCodeNoAction["REGISTER_WTH_USCIS_STP"] = "REGISTER_WTH_USCIS_STP";
    NotifyCodeNoAction["LNKWITHDRW"] = "LNKWITHDRW";
    NotifyCodeNoAction["BENUSRREQ"] = "BENUSRREQ";
    NotifyCodeNoAction["TASKREVREQ"] = "TASKREVREQ";
    NotifyCodeNoAction["TASK_AUDIT"] = "TASK_AUDIT";
    NotifyCodeNoAction["ADD_DEPENDENT"] = "ADD_DEPENDENT"; // To send notification to beneficiary, to add dependents while creating i130
})(NotifyCodeNoAction || (NotifyCodeNoAction = {}));

/*
 * Public API Surface of app-models
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APPLICANT_TABS, ATTORNEY, Address, BENEFICIARY, BENE_SELF_READ, BENE_SELF_WRITE, BENE_SPOUSE_READ, BENE_SPOUSE_WRITE, BEN_STATUSES, DEPENDENT_VISAS, DOCTYPESCONST, EYECOLORS, FOREIGN_LIST, FirmAddress, GENERATE_EFILING_FORM_CONFIG, GENERATE_FORM_CONFIG, HAIRCOLORS, IMMIGRANT_FORMS, License, MAILING_LIST, NotifyCodeAction, NotifyCodeNoAction, PACategoryDetails, PAChart, PAObservation, PERMANENT_LIST, PETITIONER, PLATFORMADMIN, STEPS_WITH_TABS_IN_POPUP, TaskStep, Template, Tranings, TravelHistory, USCIS_CONFIG, USER_PERMISSIONS, VIDEOS, VisaDetails, VisaMeta, VisaTypeList, WorkDetails, WorkDetailsLib, WorkExpDetails, acceptedFileTypes, acceptedFileTypesText, acceptedFileTypesTextPDF, fileSizeText, initialState, labelNotNeededArray, possibleDateFormats, stepStatus, userRoleRouteMapping };
//# sourceMappingURL=app-models.js.map
